import { render, staticRenderFns } from "./SecondQualityBarChartReport.vue?vue&type=template&id=5f6a8cc6&scoped=true&"
import script from "./SecondQualityBarChartReport.vue?vue&type=script&lang=js&"
export * from "./SecondQualityBarChartReport.vue?vue&type=script&lang=js&"
import style0 from "./SecondQualityBarChartReport.vue?vue&type=style&index=0&id=5f6a8cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a8cc6",
  null
  
)

export default component.exports